<div class="content-social">
  <div class="icons">
    <a
      *ngFor="let socialItem of navItemList"
      [class]="socialItem.title"
      [href]="socialItem.linkpath"
      [target]="socialItem.target"
      [title]="socialItem.title">
      <mat-icon [svgIcon]="socialItem.icon"></mat-icon>
    </a>
  </div>
</div>
